/**
 * Campaign types counted as VIDEO (MBY-456). Since MBY-367, TF1+, M6+ and Netflix are a targeting
 * option of the VIDEO lever, not levers of their own — but a legacy campaign still carries `TF1`,
 * `M6` or `NETFLIX` as its type.
 */
export const VIDEO_PLATFORM_TYPES: readonly string[] = ['TF1', 'M6', 'NETFLIX'];

/** The campaign counts per type, with the video platforms folded into `VIDEO`. */
export function foldVideoPlatforms(byType: Record<string, number> | null | undefined): Record<string, number> {
    const folded: Record<string, number> = {};
    for (const [type, count] of Object.entries(byType ?? {})) {
        const key = VIDEO_PLATFORM_TYPES.includes(type) ? 'VIDEO' : type;
        folded[key] = (folded[key] ?? 0) + count;
    }
    return folded;
}
